import React from "react";
import { Paper, Tabs, Tab, Box } from "@mui/material";

const TabGroup = ({
  tabLabels,
  handleTabChange,
  activeTab,
  hideBgColor = false,
}) => {
  return (
    <Box>
      <Paper
        elevation={0}
        sx={{
          backgroundColor: hideBgColor ? "transparent" : "#E7E8EA",
          borderRadius: "10px",
          display: "inline-block",
          padding: "4px",
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{ minHeight: 0 }}
        >
          {tabLabels.map((label, index) => (
            <Tab
              key={index}
              label={label}
              disableRipple
              sx={{
                textTransform: "none",
                fontWeight: 500,
                fontSize: 14,
                m: "2px",
                minHeight: 0,
                minWidth: "auto",
                padding: "8px 24px",
                color: "#292C2F !important",
                backgroundColor:
                  activeTab === index ? "#FFFFFF" : "transparent",
                boxShadow:
                  activeTab === index
                    ? "0px 2px 4px rgba(0, 0, 0, 0.08), 0px 0px 6px rgba(0, 0, 0, 0.02)"
                    : "none",
                borderRadius: "8px",
                transition: "background-color 0.2s ease",
                "&:hover": {
                  backgroundColor: activeTab !== index ? "#F0F0F0" : "#FFFFFF",
                },
              }}
            />
          ))}
        </Tabs>
      </Paper>
    </Box>
  );
};

export default TabGroup;
